(function () {
'use strict';
function safe(fn, name) {
try { fn(); } catch (e) { console.warn('[chiaro] ' + name + ' failed:', e); return false; }
return true;
}
var P = { open: 0, dive: 0 };
var lastY = window.scrollY || 0;
var velBoost = 0;
var CENTRE_URL = 'https://cdn.shopify.com/s/files/1/1009/9756/2685/files/composicion_relojes_fondo_transparente-2.webp';
var CHARM_URLS = [];
(function () {
var el = document.getElementById('chiaro-charm-urls');
if (!el) return;
try { CHARM_URLS = JSON.parse(el.textContent) || []; } catch (e) {}
})();
function cutWhite(img, size) {
var c = document.createElement('canvas');
var w = c.width = size, h = c.height = size;
var ctx = c.getContext('2d');
ctx.drawImage(img, 0, 0, w, h);
var data;
try { data = ctx.getImageData(0, 0, w, h); } catch (e) { return null; }
var px = data.data, seen = new Uint8Array(w * h), stack = [];
function feed(i) {
if (seen[i]) return;
var o = i * 4, r = px[o], g = px[o + 1], b = px[o + 2];
if (r < 240 || g < 240 || b < 240) return;
if (Math.max(r, g, b) - Math.min(r, g, b) > 6) return;
seen[i] = 1; stack.push(i);
}
var x, y;
for (x = 0; x < w; x++) { feed(x); feed((h - 1) * w + x); }
for (y = 0; y < h; y++) { feed(y * w); feed(y * w + w - 1); }
while (stack.length) {
var i = stack.pop();
x = i % w; y = (i / w) | 0;
if (x > 0) feed(i - 1);
if (x < w - 1) feed(i + 1);
if (y > 0) feed(i - w);
if (y < h - 1) feed(i + w);
}
var minX = w, minY = h, maxX = -1, maxY = -1;
for (var k = 0; k < w * h; k++) {
if (seen[k]) { px[k * 4 + 3] = 0; continue; }
x = k % w; y = (k / w) | 0;
if (x < minX) minX = x;
if (x > maxX) maxX = x;
if (y < minY) minY = y;
if (y > maxY) maxY = y;
}
ctx.putImageData(data, 0, 0);
return { canvas: c, minX: minX, minY: minY, maxX: maxX, maxY: maxY };
}
function loadCharm(url, size, done) {
var img = new Image();
img.crossOrigin = 'anonymous';
img.onload = function () {
var r = cutWhite(img, size || 420);
if (!r || r.maxX <= r.minX || r.maxY <= r.minY) { done(null); return; }
var w = r.maxX - r.minX + 1, h = r.maxY - r.minY + 1;
if (w < 16 || h < 16) { done(null); return; }
var trim = document.createElement('canvas');
trim.width = w; trim.height = h;
trim.getContext('2d').drawImage(r.canvas, r.minX, r.minY, w, h, 0, 0, w, h);
var tex = new THREE.CanvasTexture(trim);
tex.minFilter = THREE.LinearFilter;
tex.magFilter = THREE.LinearFilter;
tex.encoding = THREE.sRGBEncoding;
tex.center.set(0.5, 0.5);
tex.rotation = Math.PI / 2;
done({ tex: tex, aspect: w / h });
};
img.onerror = function () { done(null); };
img.src = url;
}
var threeOK = false;
function initThree() {
if (!window.THREE) throw new Error('THREE not loaded');
var mount = document.getElementById('hero-canvas');
var W = mount.clientWidth || window.innerWidth;
var H = mount.clientHeight || window.innerHeight;
var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.setSize(W, H);
renderer.outputEncoding = THREE.sRGBEncoding;
mount.appendChild(renderer.domElement);
var scene = new THREE.Scene();
var camera = new THREE.PerspectiveCamera(38, W / H, 0.1, 300);
camera.position.set(0, 0, 9.4);
scene.add(new THREE.HemisphereLight(0xfff6e6, 0x4a3b28, 0.95));
var key = new THREE.DirectionalLight(0xfff1d6, 1.05);
key.position.set(4, 6, 7);
scene.add(key);
var rim = new THREE.PointLight(0xfdb5cd, 0.7, 60);
rim.position.set(-7, -3, 5);
scene.add(rim);
var LINKS = 16;
var BASE_R = 2.75;
var TANG = 0.74;
var DEPTH = 0.085;
var goldMat = new THREE.MeshPhongMaterial({
color: 0xb9955d, specular: 0xfff3d6, shininess: 62
});
var goldDark = new THREE.MeshPhongMaterial({
color: 0x8f7345, specular: 0xffe9bd, shininess: 40
});
var crystalMat = new THREE.MeshPhongMaterial({
color: 0xffffff, specular: 0xffffff, shininess: 100, emissive: 0x444036
});
var ringGroup = new THREE.Group();
scene.add(ringGroup);
var links = [];
var i, ang, holder, face, inner, mesh;
for (i = 0; i < LINKS; i++) {
ang = (i / LINKS) * Math.PI * 2;
holder = new THREE.Group();
holder.rotation.z = ang;
ringGroup.add(holder);
mesh = new THREE.Group();
var faceMat = new THREE.MeshBasicMaterial({ color: 0xb9955d, transparent: true, side: THREE.DoubleSide });
var backMat = new THREE.MeshBasicMaterial({ color: 0x9c7f49, transparent: true, side: THREE.DoubleSide });
var faceGeo = new THREE.PlaneGeometry(TANG / 1.2, TANG);
var back = new THREE.Mesh(faceGeo.clone(), backMat);
var face = new THREE.Mesh(faceGeo, faceMat);
back.position.set(0.032, -0.034, -DEPTH);
mesh.add(back);
mesh.add(face);
if (CHARM_URLS.length) {
(function (fm, bm, fMesh, bMesh, url) {
loadCharm(url, 420, function (charm) {
if (!charm) return;
var g = new THREE.PlaneGeometry(TANG / charm.aspect, TANG);
fMesh.geometry.dispose(); bMesh.geometry.dispose();
fMesh.geometry = g; bMesh.geometry = g.clone();
fm.map = charm.tex; fm.color.set(0xffffff); fm.needsUpdate = true;
bm.map = charm.tex; bm.needsUpdate = true;
});
})(faceMat, backMat, face, back, CHARM_URLS[i % CHARM_URLS.length]);
}
mesh.position.x = BASE_R;
mesh.userData.spin = (Math.random() - 0.5) * 2.4;
mesh.userData.push = 1.4 + Math.random() * 1.2;
holder.add(mesh);
links.push(mesh);
}
ringGroup.rotation.x = -1.05;
var centrepiece = null;
(function () {
var mat = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0, depthWrite: false });
var mesh = new THREE.Mesh(new THREE.PlaneGeometry(4.0, 4.0), mat);
mesh.position.set(0, -0.25, 0.25);
scene.add(mesh);
var loader = new THREE.TextureLoader();
loader.setCrossOrigin('anonymous');
loader.load(CENTRE_URL, function (t) {
t.minFilter = THREE.LinearFilter;
t.magFilter = THREE.LinearFilter;
t.encoding = THREE.sRGBEncoding;
mat.map = t;
mat.needsUpdate = true;
centrepiece = mesh;
});
})();
function charmTexture(idx, gold) {
var c = document.createElement('canvas');
c.width = 256; c.height = 320;
var ctx = c.getContext('2d');
var g = ctx.createLinearGradient(0, 0, 256, 320);
if (gold) { g.addColorStop(0, '#f3e2c2'); g.addColorStop(1, '#ad8d56'); }
else      { g.addColorStop(0, '#f2f3f5'); g.addColorStop(1, '#a9adb4'); }
ctx.fillStyle = g;
ctx.fillRect(0, 0, 256, 320);
ctx.strokeStyle = 'rgba(23,23,23,.28)';
ctx.lineWidth = 3;
ctx.strokeRect(12, 12, 232, 296);
ctx.fillStyle = 'rgba(255,255,255,.85)';
ctx.font = '600 84px Arial';
ctx.textAlign = 'center';
ctx.fillText('\u2726', 128, 170);
ctx.fillStyle = 'rgba(23,23,23,.62)';
ctx.font = '600 21px Arial';
ctx.fillText('CHARM ' + (idx + 1), 128, 282);
ctx.textAlign = 'left';
ctx.font = '600 13px Arial';
ctx.fillStyle = 'rgba(23,23,23,.4)';
ctx.fillText('IMG', 20, 34);
var tex = new THREE.CanvasTexture(c);
tex.minFilter = THREE.LinearFilter;
tex.magFilter = THREE.LinearFilter;
return tex;
}
var charmRings = [];
var planeItems = [];
var ringSpec = [ { count: 8, radius: 4.7, size: 1.15 }, { count: 10, radius: 6.3, size: 1.45 } ];
ringSpec.forEach(function (spec, rI) {
var rg = new THREE.Group();
scene.add(rg);
charmRings.push(rg);
var j;
for (j = 0; j < spec.count; j++) {
var line = new THREE.Group();
line.rotation.z = (j / spec.count) * Math.PI * 2;
rg.add(line);
var tex = charmTexture(rI * 8 + j, (j % 2 === 0));
var mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true, opacity: 0, side: THREE.DoubleSide });
var backMat = new THREE.MeshBasicMaterial({ map: tex, color: 0x7d6339, transparent: true, opacity: 0, side: THREE.DoubleSide });
var pl = new THREE.Group();
var diveGeo = new THREE.PlaneGeometry(spec.size * 0.8, spec.size);
var diveBack = new THREE.Mesh(diveGeo.clone(), backMat);
var diveFace = new THREE.Mesh(diveGeo, mat);
diveBack.position.z = -spec.size * 0.045;
pl.add(diveBack);
pl.add(diveFace);
pl.userData.mats = [mat, backMat];
if (CHARM_URLS.length) {
(function (fm, bm, fMesh, bMesh, u, size) {
loadCharm(u, 420, function (charm) {
if (!charm) return;
var g = new THREE.PlaneGeometry(size / charm.aspect, size);
fMesh.geometry.dispose(); bMesh.geometry.dispose();
fMesh.geometry = g; bMesh.geometry = g.clone();
fm.map = charm.tex; fm.needsUpdate = true;
bm.map = charm.tex; bm.needsUpdate = true;
});
})(mat, backMat, diveFace, diveBack, CHARM_URLS[(rI * 8 + j) % CHARM_URLS.length], spec.size);
}
pl.position.x = spec.radius;
pl.rotation.z = -Math.PI / 2;
pl.userData.delay = 0.05 + Math.random() * 0.45;
line.add(pl);
planeItems.push(pl);
}
});
function onResize() {
W = mount.clientWidth || window.innerWidth;
H = mount.clientHeight || window.innerHeight;
camera.aspect = W / H;
camera.updateProjectionMatrix();
renderer.setSize(W, H);
}
window.addEventListener('resize', onResize);
function ease(t) { return t * t * (3 - 2 * t); }
function tick() {
var y = window.scrollY || 0;
var v = Math.abs(y - lastY);
lastY = y;
velBoost = Math.max(velBoost * 0.9, Math.min(3.2, v * 0.045));
var rotSpeed = 0.0035 * (1 + velBoost);
ringGroup.rotation.z += rotSpeed;
charmRings.forEach(function (rg, idx) {
rg.rotation.z += rotSpeed * 0.7 * (idx % 2 === 0 ? -1 : 1);
});
var o = ease(P.open);
if (centrepiece) {
centrepiece.material.opacity = Math.max(0, 1 - o * 2.2);
centrepiece.position.y = -0.25 + Math.sin(Date.now() * 0.0011) * 0.06;
}
ringGroup.rotation.x = -1.05 + o * 0.92;
ringGroup.position.y = -0.15 * (1 - o);
var k;
for (k = 0; k < links.length; k++) {
var m = links[k];
m.position.x = BASE_R + o * m.userData.push;
m.rotation.z = o * m.userData.spin;
m.rotation.y = o * m.userData.spin * 0.6;
}
var d = P.dive;
var p;
for (k = 0; k < planeItems.length; k++) {
p = planeItems[k];
var dl = p.userData.delay;
var t = (d - dl) / (0.98 - dl);
if (t < 0) t = 0; if (t > 1) t = 1;
t = ease(t);
p.position.z = -70 * (1 - t);
var mats = p.userData.mats;
for (var mi = 0; mi < mats.length; mi++) mats[mi].opacity = t;
}
renderer.render(scene, camera);
requestAnimationFrame(tick);
}
tick();
threeOK = true;
}
if (!safe(initThree, 'three')) {
document.documentElement.classList.add('no3d');
}
function initScroll() {
if (!window.gsap || !window.ScrollTrigger) throw new Error('gsap not loaded');
gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.create({
start: 60,
onEnter: function () { document.querySelector('.site-header').classList.add('is-scrolled'); },
onLeaveBack: function () { document.querySelector('.site-header').classList.remove('is-scrolled'); }
});
gsap.set('.hero-base', { autoAlpha: 0 });
var tl = gsap.timeline({
scrollTrigger: {
trigger: '.hero',
start: 'top top',
end: '+=3000',
scrub: 0.6,
pin: true,
anticipatePin: 1
}
});
tl.to('.scroll-cue', { autoAlpha: 0, duration: 0.18 }, 0);
tl.to('.hero-copy--intro', { yPercent: -42, autoAlpha: 0, ease: 'power2.in', duration: 0.5 }, 0.05);
tl.to(P, { open: 1, ease: 'power2.inOut', duration: 1 }, 0);
tl.to(P, { dive: 1, ease: 'none', duration: 1.05 }, 0.38);
tl.to('#hero-canvas', { autoAlpha: 0, duration: 0.45, ease: 'power1.in' }, 1.5);
tl.to('.ring-fallback', { autoAlpha: 0, duration: 0.45 }, 1.5);
tl.to('.hero-base', { autoAlpha: 1, duration: 0.35 }, 1.5);
tl.fromTo('.base-row', { yPercent: -260 }, { yPercent: 0, ease: 'power2.out', duration: 0.8 }, 1.5);
tl.fromTo('.hero-base .stagger',
{ y: 34, autoAlpha: 0 },
{ y: 0, autoAlpha: 1, stagger: 0.09, duration: 0.5 }, 1.85);
tl.to({}, { duration: 0.35 });
gsap.fromTo('.charms .reveal-inner',
{ yPercent: 120 },
{
yPercent: 0, stagger: 0.1, ease: 'power3.out', duration: 0.9,
scrollTrigger: { trigger: '.charms', start: 'top 68%' }
});
gsap.fromTo('.orbit',
{ scale: 0.72, autoAlpha: 0 },
{
scale: 1, autoAlpha: 1, ease: 'none',
scrollTrigger: { trigger: '.charms', start: 'top bottom', end: 'top top', scrub: 0.5 }
});
gsap.fromTo('.charms-data',
{ autoAlpha: 0, y: 20 },
{
autoAlpha: 1, y: 0, duration: 0.7,
scrollTrigger: { trigger: '.charms', start: 'top 45%' }
});
var charmsTl = gsap.timeline({
scrollTrigger: {
trigger: '.charms',
start: 'top top',
end: 'bottom bottom',
scrub: 0.6
}
});
charmsTl.fromTo('.marquee-block', { yPercent: 108 }, { yPercent: 0, ease: 'none' }, 0);
charmsTl.to('.charms-copy', {
y: function () { return -window.innerHeight * 0.17; },
scale: 0.86, transformOrigin: '50% 50%', ease: 'none'
}, 0);
charmsTl.to('.orbit', { yPercent: -14, ease: 'none' }, 0);
charmsTl.to('.charms-data', { autoAlpha: 0, ease: 'none', duration: 0.35 }, 0);
charmsTl.to({}, { duration: 0.62 });
gsap.fromTo('.collections .reveal-inner',
{ yPercent: 120 },
{
yPercent: 0, ease: 'power3.out', duration: 0.9,
scrollTrigger: { trigger: '.collections', start: 'top 72%' }
});
gsap.fromTo('.col-card',
{ y: 52, autoAlpha: 0 },
{
y: 0, autoAlpha: 1, stagger: 0.08, duration: 0.7, ease: 'power2.out',
scrollTrigger: { trigger: '.col-row', start: 'top 82%' }
});
gsap.fromTo('.beach-copy',
{ y: 40, autoAlpha: 0 },
{
y: 0, autoAlpha: 1, duration: 0.8, ease: 'power2.out',
scrollTrigger: { trigger: '.beach', start: 'top 62%' }
});
gsap.fromTo('.beach-hero > img',
{ scale: 1 },
{
scale: 1.16, ease: 'none',
scrollTrigger: { trigger: '.beach', start: 'top bottom', end: 'bottom top', scrub: true }
});
gsap.fromTo('.beach-mosaic figure',
{ y: 44, autoAlpha: 0 },
{
y: 0, autoAlpha: 1, stagger: 0.12, duration: 0.7, ease: 'power2.out',
scrollTrigger: { trigger: '.beach-mosaic', start: 'top 88%' }
});
gsap.fromTo('.reviews .reveal-inner',
{ yPercent: 120 },
{
yPercent: 0, ease: 'power3.out', duration: 0.9,
scrollTrigger: { trigger: '.reviews', start: 'top 72%' }
});
gsap.fromTo('.review-card',
{ y: 56, autoAlpha: 0 },
{
y: 0, autoAlpha: 1, stagger: 0.12, duration: 0.75, ease: 'power2.out',
scrollTrigger: { trigger: '.reviews-grid', start: 'top 80%' }
});
gsap.fromTo('.giftbar-inner',
{ y: 30, autoAlpha: 0 },
{
y: 0, autoAlpha: 1, duration: 0.7, ease: 'power2.out',
scrollTrigger: { trigger: '.giftbar', start: 'top 88%' }
});
gsap.fromTo('.footer-banner, .footer-brand',
{ yPercent: 34, autoAlpha: 0 },
{
yPercent: 0, autoAlpha: 1, duration: 1, ease: 'power3.out',
scrollTrigger: { trigger: '.footer', start: 'top 72%' }
});
var playBtn = document.getElementById('chiaro-play');
if (playBtn && tl.scrollTrigger) {
playBtn.addEventListener('click', function () {
var target = tl.scrollTrigger.end;
var start = window.pageYOffset, dist = target - start;
if (dist <= 0) return;
var t0 = null, stop = false;
var DURATION = 9000;
function bail() { stop = true; cleanup(); }
function cleanup() {
playBtn.classList.remove('is-running');
window.removeEventListener('wheel', bail);
window.removeEventListener('touchstart', bail);
window.removeEventListener('keydown', bail);
}
window.addEventListener('wheel', bail, { passive: true });
window.addEventListener('touchstart', bail, { passive: true });
window.addEventListener('keydown', bail);
playBtn.classList.add('is-running');
function step(ts) {
if (stop) return;
if (t0 === null) t0 = ts;
var p = Math.min(1, (ts - t0) / DURATION);
window.scrollTo(0, start + dist * p);
if (p < 1) { requestAnimationFrame(step); } else { cleanup(); }
}
requestAnimationFrame(step);
});
}
window.addEventListener('load', function () { ScrollTrigger.refresh(); });
}
if (!safe(initScroll, 'scroll')) {
document.documentElement.classList.add('no-anim');
}
function initGiftBar() {
[].slice.call(document.querySelectorAll('.giftbar-inner')).forEach(setupBar);
}
function setupBar(wrap) {
var slides = [].slice.call(wrap.querySelectorAll('.gslide'));
if (slides.length < 2) return;
wrap.classList.add('is-live');
var dots = document.createElement('div');
dots.className = 'gdots';
slides.forEach(function (s, i) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'gdot';
b.setAttribute('aria-label', 'Show message ' + (i + 1));
b.addEventListener('click', function () { go(i); start(); });
dots.appendChild(b);
});
wrap.appendChild(dots);
var cur = 0, timer = null;
var bar = wrap.closest ? wrap.closest('.giftbar') : wrap.parentNode;
function go(i) {
slides[cur].classList.remove('is-on');
dots.children[cur].classList.remove('is-on');
cur = (i + slides.length) % slides.length;
slides[cur].classList.add('is-on');
dots.children[cur].classList.add('is-on');
if (bar) {
bar.classList.remove('tone-2', 'tone-3');
var tone = cur % 3;
if (tone) bar.classList.add('tone-' + (tone + 1));
}
}
var step = (bar && bar.classList.contains('giftbar--rev')) ? -1 : 1;
function start() { stop(); timer = setInterval(function () { go(cur + step); }, 3200); }
var swipe = 0, held = false;
wrap.addEventListener('wheel', function (e) {
if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
e.preventDefault();
swipe += e.deltaX;
if (!held && Math.abs(swipe) > 55) {
go(cur + (swipe > 0 ? 1 : -1));
start();
held = true;
setTimeout(function () { held = false; swipe = 0; }, 420);
}
}, { passive: false });
var touchX = null;
wrap.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
wrap.addEventListener('touchend', function (e) {
if (touchX === null) return;
var dx = e.changedTouches[0].clientX - touchX;
if (Math.abs(dx) > 45) { go(cur + (dx < 0 ? 1 : -1)); start(); }
touchX = null;
}, { passive: true });
function stop() { if (timer) { clearInterval(timer); timer = null; } }
go(0);
wrap.addEventListener('mouseenter', stop);
wrap.addEventListener('mouseleave', start);
start();
}
safe(initGiftBar, 'giftbar');
function initCutImages() {
var imgs = [].slice.call(document.querySelectorAll('img[data-cut]'));
if (!imgs.length) return;
imgs.forEach(function (el) {
var src = el.getAttribute('src');
if (!src) return;
var probe = new Image();
probe.crossOrigin = 'anonymous';
probe.onload = function () {
var r = cutWhite(probe, 420);
if (!r || r.maxX <= r.minX || r.maxY <= r.minY) return;
var w = r.maxX - r.minX + 1, h = r.maxY - r.minY + 1;
var trim = document.createElement('canvas');
trim.width = w; trim.height = h;
trim.getContext('2d').drawImage(r.canvas, r.minX, r.minY, w, h, 0, 0, w, h);
try { el.src = trim.toDataURL('image/png'); } catch (e) {}
};
probe.src = src;
});
}
safe(initCutImages, 'cut-images');
function initToneSwitch() {
[].slice.call(document.querySelectorAll('.base-card')).forEach(function (card) {
var img = card.querySelector('.base-media img');
var add = card.querySelector('.base-add');
var sws = [].slice.call(card.querySelectorAll('.base-sw'));
if (!img || !add || !sws.length) return;
sws.forEach(function (sw) {
sw.addEventListener('click', function () {
var tone = sw.getAttribute('data-tone');
var src = card.getAttribute('data-' + tone + '-img');
var variant = card.getAttribute('data-' + tone + '-var');
if (!src || !variant) return;
img.src = src;
add.href = add.href.replace(/\/cart\/\d+:1/, '/cart/' + variant + ':1');
sws.forEach(function (o) { o.classList.toggle('is-on', o === sw); });
});
});
});
}
safe(initToneSwitch, 'tone-switch');
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { window.location.reload(); });
}
})();
